var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.856 10.624L10.715 33.766a3.647 3.647 0 000 5.143L21 49.194a3.647 3.647 0 005.143 0l23.141-23.142a3.647 3.647 0 000-5.142L39 10.624a3.647 3.647 0 00-5.143 0zm12.857 12.857L23.571 46.623 13.286 36.337l2.571-2.571L21 38.909l2.571-2.572-5.142-5.142L21 28.623l5.143 5.143 2.57-2.571-5.142-5.143 2.572-2.571 5.142 5.142 2.571-2.57-5.142-5.143 2.571-2.572 5.143 5.143 2.571-2.572-5.143-5.142 2.572-2.571L46.713 23.48z",
    fill: "#E3B05F"
  })));
}

export default SvgRuler;